(function() {
  'use strict';

  var KLAVIYO_PUBLIC_KEY = 'YxhV4A';
  var EVENT_NAME = 'Price Requested';

  function initForms() {
    var forms = document.querySelectorAll('.por-form');
    forms.forEach(function(formContainer) {
      var form = formContainer.querySelector('.por-form__form');
      if (!form || form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        handleSubmit(formContainer, form);
      });
    });
  }

  function handleSubmit(formContainer, form) {
    var submitButton = form.querySelector('.por-form__submit');
    var successEl = formContainer.querySelector('.por-form__success');
    var errorEl = formContainer.querySelector('.por-form__error');

    var name = form.querySelector('#por-name').value.trim();
    var email = form.querySelector('#por-email').value.trim();
    var phone = form.querySelector('#por-phone').value.trim();

    if (!name || !email) {
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = 'Sending...';
    errorEl.hidden = true;

    var payload = {
      token: KLAVIYO_PUBLIC_KEY,
      event: EVENT_NAME,
      customer_properties: {
        $email: email,
        $first_name: name,
        $phone_number: phone || null
      },
      properties: {
        product_id: formContainer.dataset.productId,
        product_title: formContainer.dataset.productTitle,
        product_url: formContainer.dataset.productUrl,
        product_handle: formContainer.dataset.productHandle,
        variant_id: formContainer.dataset.variantId,
        price: formContainer.dataset.price,
        price_formatted: formContainer.dataset.priceFormatted,
        vendor: formContainer.dataset.vendor,
        promo_banner: formContainer.dataset.promoBanner || null,
        cart_permalink: formContainer.dataset.cartPermalink,
        product_image: formContainer.dataset.productImage,
        product_reference: formContainer.dataset.productReference || null
      }
    };

    sendToKlaviyo(payload)
      .then(function(success) {
        if (success) {
          var requestBlock = formContainer.querySelector('[data-por-request]');
if (requestBlock) requestBlock.hidden = true;
          successEl.hidden = false;
        } else {
          throw new Error('Klaviyo returned failure');
        }
      })
      .catch(function(err) {
        console.error('Price request failed:', err);
        errorEl.hidden = false;
        submitButton.disabled = false;
        submitButton.textContent = 'Get Price';
      });
  }

  function sendToKlaviyo(payload) {
  var body = {
    data: {
      type: 'event',
      attributes: {
        properties: payload.properties,
        metric: {
          data: {
            type: 'metric',
            attributes: { name: payload.event }
          }
        },
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: payload.customer_properties.$email,
              first_name: payload.customer_properties.$first_name,
              phone_number: payload.customer_properties.$phone_number
            }
          }
        }
      }
    }
  };

  var url = 'https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_PUBLIC_KEY;

  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2024-10-15'
    },
    body: JSON.stringify(body)
  })
  .then(function(response) {
    return response.status === 202 || response.status === 200;
  });
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForms);
  } else {
    initForms();
  }
})();